import { Select, SelectProps } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
`;

export const Title = styled.h2`
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 20px;
`;

export const AgreementSection = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

export const CheckboxWrapper = styled.div`
  margin-bottom: 10px;
  text-align: start;
`;

export const TextareaWrapper = styled.div`
  width: 100%;
  textarea {
    width: 100%;
    height: 100px;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 10px;
    resize: none;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 20px;
`;

export const FormRow = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
margin-right: 20px;
font-weight: 500;
font-size: 15px;
`;

export const InputGroup = styled.div`
  display: flex;
  align-items: center;
`;

export const Input = styled.input`
  width: 80px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  &:not(:last-child) {
    margin-right: 8px;
  }
`;

export const Button = styled.button`
  padding: 10px 20px;
  background-color: #225f9b;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &:disabled {
    background-color: #ddd;
  }
`;

export const StyledSelect = styled(Select) <SelectProps<string>>`
  border-radius: 4px;
  min-width: 200px;
`;

export const BorderBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border: 1px solid #ddd;
  padding: 20px;
`;
